export default {
      id: "filter-usage",
      viewBox: "0 0 22 17",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#filter",
      toString: function () {
        return this.url;
      }
    }